import * as yup from 'yup';

export default yup.object().shape({
  profile: yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    usernameArup: yup.string().required('Username is required'),
    arupPassword: yup.string().required('Password is required'),
    regions: yup.array().required('Region is required'),
    phone: yup.string().required('Phone is required'),
    address: yup.string(),
  }),
});
